import { startTransition } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';

// No StrictMode here (the default entry adds one): root.tsx applies StrictMode inside the
// providers so <Snackbar/> stays outside it, as src/index.tsx did.
//
// Parity with developer's <BrowserRouter>:
// - useTransitions={false}: BrowserRouter wrapped no navigation in a transition, and URL-driven
//   state must not render a step behind same-tick updates. Enabling transitions is its own change.
// - onError -> window.reportError: the root ErrorBoundary would otherwise swallow render crashes
//   into a console log; re-reporting keeps them uncaught errors for Datadog's
//   forwardErrorsToLogs, as under CRA.
startTransition(() => {
  hydrateRoot(
    document,
    <HydratedRouter useTransitions={false} onError={(error) => window.reportError(error)} />,
  );
});
